import styled from 'styled-components'
import { LogoAuthenticated, LogoChristmasAuthenticated } from 'components/NavBar/svg'
import { isChristmas } from 'helper/date'

const HeaderContainer = styled.div`
  background-color: #005EB8;
  padding: 0 2rem;
  height: 60px;
  display: flex;
  align-items: center;
  width: 100%;
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: default;
`

export const HeaderPatient = () => {
  let logo = <LogoAuthenticated />
  if (isChristmas()) {
    logo = <LogoChristmasAuthenticated />
  }

  return (
    <HeaderContainer>
      <LogoContainer>
        {logo}
      </LogoContainer>
    </HeaderContainer>
  )
}

